import React from 'react';
import { BaseFilterProps, DropDownFilter } from 'framework/list';
import WasteTypeDropdown from '../inputs/WasteTypeDropdown';

const WasteTypeFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <WasteTypeDropdown source={source} />
    </DropDownFilter>
  );
};

export default WasteTypeFilter;
